import { Avatar, Fade as MuiFade } from '@mui/material'

import { GachaItemDetailFragment } from '@/clients/utoniq-core/schema'
import { ItemReversibleThumbnail } from '@/components/organisms/item/ItemReversableThumbnail'
import { Cell, CellFrame } from '@/core/architecture'

type ItemWithRarityCellProps = {
  item: GachaItemDetailFragment
  onClick: () => void
  flipped: boolean
}
/**
 * @description
 * レアリティ表示を含むアイテム表示コンポーネント
 */
export const ItemWithRarityCell: Cell<ItemWithRarityCellProps> = ({
  item,
  onClick,
  flipped,
}) => {
  return (
    <CellFrame sx={{ position: 'relative' }}>
      <ItemReversibleThumbnail
        loading={!item}
        imageAreaProps={{
          thumbnail: item?.thumbnail,
          size: 'medium-small',
          onClick,
        }}
        flipProps={{ isFlipped: !flipped }}
      />

      {item?.rarityIconImage?.smallUri && (
        <MuiFade in={flipped}>
          <Avatar
            variant="square"
            src={item.rarityIconImage.smallUri}
            sx={{
              mt: 1,
              height: 24,
              width: 'fit-content',
              mx: 'auto',
            }}
          />
        </MuiFade>
      )}
    </CellFrame>
  )
}
